import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xingternal/button';

import { PageContext } from '@xingternal/pages-common';
import { getTrackingUrl } from '@xingternal/pages-tracking';

import styles from './BackButton.css';

type BackButtonProps = {
  pageSlug: string;
};

const BackButton = ({ pageSlug }: BackButtonProps) => {
  const { pageContext } = useContext(PageContext);
  return (
    <div className={styles.buttonWrapper}>
      <Button
        data-cy="back_to_overview"
        variant={'secondary'}
        size={'medium'}
        className={styles.button}
        to={getTrackingUrl({
          to: `${pageContext?.basePath}/${pageSlug}`,
          trackingKey: 'backToOverviewFromContactSubpage',
        })}
      >
        <FormattedMessage
          id={'EP_BACK_TO_OVERVIEW'}
          defaultMessage={'EP_BACK_TO_OVERVIEW'}
        />
      </Button>
    </div>
  );
};

export default BackButton;
